export const getPlanUsageIntervalsPro = () => [
  {
    min: 0,
    max: 5000,
    price: 75,
    label: '5k',
  },
  {
    min: 5000,
    max: 8000,
    price: 120,
    label: '8k',
  },
  {
    min: 8000,
    max: 12000,
    price: 190,
    label: '12k',
  },
  {
    min: 12000,
    max: 20000,
    price: 310,
    label: '20k',
  },
  {
    min: 20000,
    max: 35000,
    price: 500,
    label: '35k',
  },
  {
    min: 35000,
    max: 50000,
    price: 790,
    label: '50k',
  },
  {
    min: 50000,
    max: 80000,
    price: 1260,
    label: '80k',
  },
  {
    min: 80000,
    max: 130000,
    price: 2013,
    label: '130k',
  },
  {
    min: 130000,
    max: 150000,
    price: 3200,
    label: '150k+',
  },
];

export const getPlanUsageIntervalsEnterprise = () => [
  {
    min: 0,
    max: 35000,
    price: 500,
    label: '35k',
  },
  {
    min: 35000,
    max: 50000,
    price: 790,
    label: '50k',
  },
  {
    min: 50000,
    max: 80000,
    price: 1260,
    label: '80k',
  },
  {
    min: 80000,
    max: 130000,
    price: 2013,
    label: '130k',
  },
  {
    min: 130000,
    max: 150000,
    price: 3200,
    label: '150k+',
  },
];
